import { Component, JSXElement } from "solid-js";

export interface HeadingProps {
  children?: JSXElement;
}

export const Heading: Component<HeadingProps> = (props) => {
  return <h1 class="mb-4 text-4xl leading-10 font-bold">{props.children}</h1>;
};
